const CDN_URL = process.env.REACT_APP_CDN_URL;

const getCdnUrl = (path) => CDN_URL.concat(path);

export { getCdnUrl }; // eslint-disable-line import/prefer-default-export
